/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import './css/Start.css';
import Footer from "./components/Footer";
import Impressum from "./components/Impressum";
import Register from "./components/Register";
import Activate from "./components/Activate";
import ActivateEMail from "./components/ActivateEMail";
import Login from "./components/Login";
import SuccessText from "./components/SuccessText";
import OrderContract from "./components/OrderContract";
import OrderSuccess from "./components/OrderSuccess";
import ResetPasswordSuccess from './components/ResetPasswordSuccess';
import ActivateSuccess from './components/ActivateSuccess';
import ActivateEMailSuccessOffline from './components/ActivateEMailSuccessOffline';
import OfflineMenu from "./OfflineMenu";
import Test from "./components/Test";
import ResetPassword from "./components/ResetPassword";
import ErrorOffline from "./components/ErrorOffline";
import ErrorLogin from "./components/ErrorLogin";

class Start  extends Component
{
  render()
  {
    return (
      <div>
        <OfflineMenu />
        <div style={{ margin: '60px',textAlign:'center' }}>
          <Switch>
            <Route path='/orderSuccess' component={OrderSuccess} />
            <Route path='/order' component={OrderContract} />
            <Route path='/impressum' component={Impressum} />
            <Route path='/login' component={Login} />
            <Route path='/register' component={Register} />
            <Route path='/changeMail/:id' component={ActivateEMail} />
            <Route path='/activateEMailSuccessOffline' component={ActivateEMailSuccessOffline} />
            <Route path='/activateSuccess' component={ActivateSuccess} />
            <Route path='/activate/:id' component={Activate} />
            <Route path='/successText' component={SuccessText} />
            <Route path='/resetPasswordSuccess' component={ResetPasswordSuccess} />
            <Route path='/resetPassword' component={ResetPassword} />
            <Route path='/test' component={Test} />
            <Route path='/errorOffline' component={ErrorOffline} />
            <Route path='/error' component={ErrorLogin} />
            <Route path='/' component={OrderContract} />
          </Switch>
        </div>
        <Footer />
      </div>
    );
  }
}
export default Start;
